
import { useL10n } from '@uplift/hooks';
import { ContactSupportContainer } from '@uplift/pages';
import { ProviderLayout, ProviderLayoutPageHeader } from '@uplift/ui-v2';

export const SupportPage = () => {
  const l10n = useL10n();

  return (
    <ProviderLayout>
      <ProviderLayoutPageHeader
        title={l10n.support.pageTitle}
      />
      <ContactSupportContainer />
    </ProviderLayout>
  );
};
